import { styled } from "@mui/material";
import React, { FC } from "react";

const PollExpired: FC = (props) => <span {...props}>Poll expired</span>

export default styled(PollExpired)`
    color: red;
`;